import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from './../../../../../../core/toast.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { AddSupplyBrandService } from '../../services/add-supply-brand.service';

@Component({
  selector: 'app-add-supply-brand',
  templateUrl: './add-supply-brand.component.html',
  styleUrls: ['./add-supply-brand.component.scss']
})
export class AddSupplyBrandComponent implements OnInit {

  supplyBrandForm = this.fb.group({
    name: [null, [Validators.required]]
  })

  constructor(
    private fb: FormBuilder,
    private addSupplyBrandService: AddSupplyBrandService,
    private toast: ToastService,
    private matDialogRef: MatDialogRef<AddSupplyBrandComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if(this.data && this.data.name){
      this.name.setValue(this.data.name);
    }
  }


  async addSupplyBrand(){
    if(this.supplyBrandForm.invalid){
      this.toast.openSnackBar('Please enter valid name');
      this.supplyBrandForm.markAllAsTouched();
      return;
    }
    const supplyBrand = this.supplyBrandForm.value as any;
    try {
      const response = await this.addSupplyBrandService.addSupplyBrand(supplyBrand);
      this.toast.openSnackBar('Supply brand added successfully');
      this.closeDialog(response);
    } catch(error){
      this.toast.openSnackBar('Unable to add supply brand');
    }

  }

  closeDialog(status: any){
        document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.matDialogRef.close(status); }, 1000);
  }

  /* --------------------------------- Getters -------------------------------- */

  get name(){
    return this.supplyBrandForm.get('name')
  }
}

